/** Longest line of a category label, in characters: the longest single word ("Потребительские"). */
const LABEL_LINE_CHARS = 15

/**
 * Wraps a category label between words. ECharts' own `overflow: 'break'` splits Cyrillic words
 * in the middle, so labels are wrapped here and drawn without a width limit.
 */
export const wrapLabel = (text: string, lineChars = LABEL_LINE_CHARS): string =>
  text
    .split(' ')
    .reduce<string[]>((lines, word) => {
      const last = lines.at(-1)

      if (last !== undefined && last.length + 1 + word.length <= lineChars) {
        lines[lines.length - 1] = `${last} ${word}`
      } else {
        lines.push(word)
      }

      return lines
    }, [])
    .join('\n')
